import { defineStore } from 'pinia';
import { PermissionType } from '@/router/types';
import { permissionRoutes } from '@/router/routes'; // 导入权限路由
import { RouteRecordRaw } from 'vue-router';

interface PermissionState {
  permissions: PermissionType[];
  accessRoutes: RouteRecordRaw[]; // 新增：存储有权限的路由
  // 超级管理员标识
  isSuperAdmin: boolean;
}

export const usePermissionStore = defineStore('permission', {
  state: (): PermissionState => ({
    permissions: [],
    accessRoutes: [], // 初始化空数组
    isSuperAdmin: false // 初始化超级管理员标识为false
  }),
  actions: {
    // 设置权限并生成有权限的路由
    setPermissions(permissions: PermissionType[]) {
      this.permissions = permissions;
      // 生成有权限的路由
      this.accessRoutes = this.filterRoutes(permissionRoutes);
    },

    // 递归过滤有权限的路由（纯函数，不修改原始路由对象）
    filterRoutes(routes: RouteRecordRaw[]): RouteRecordRaw[] {
      return routes
        .filter(route => {
          if (route.meta?.permission) {
            return this.hasPermission(route.meta.permission);
          }
          return true;
        })
        .map(route => {
          if (route.children && route.children.length) {
            return { ...route, children: this.filterRoutes(route.children) };
          }
          return route;
        });
    },

    // 检查是否拥有权限（保持不变）
    hasPermission(permission: PermissionType | PermissionType[]): boolean {
      if (Array.isArray(permission)) {
        return permission.some(p => this.permissions.includes(p));
      }
      return this.permissions.includes(permission);
    }
  }
});